import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from "@angular/core";
import {FormShip, Vessel} from "@portbase/bezoekschip-service-typescriptmodels";
import {sendQuery} from "../../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-vessel-ship',
    templateUrl: './exemptions_vessel_ship.component.html',
    styleUrls: ['./exemptions_vessel_ship.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionsVesselShipComponent {

  @Input() formShip : FormShip;
  @Input() vesselPrefix: string;
  @Input() shipLabelTooltip: string;

  @Output() removeShip = new EventEmitter<void>();

  vessel: Vessel;

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  vesselNameFormatter = (vessel: Vessel) => {
    return vessel.name + ' – ' + vessel.imoCode;
  };

  onVesselChange() {
    this.formShip.imo = this.vessel?.imoCode;
    this.formShip.name = this.vessel?.name;
  }

  notifyParent() {
    this.removeShip.emit(); // Emit event to parent
  }
}
